import "unfetch/polyfill";
import "es6-promise/auto";
import { AddressForm } from '@shopify/theme-addresses';
import { e } from '../helper/functions';

let addresses = document.querySelectorAll('[data-address=root]');

addresses.forEach((address, i) => {
  let id = address.dataset.id;
  let selectors = {
    lastName: '#' + id + '_last_name',
    firstName: '#' + id + '_first_name',
    company: '#' + id + '_company',
    address1: '#' + id + '_address1',
    address2: '#' + id + '_address2',
    country: '#' + id + '_country',
    zone: '#' + id + '_province',
    postalCode: '#' + id + '_zip',
    city: '#' + id + '_city',
    phone: '#' + id + '_phone'
  };

  AddressForm(address, 'en', selectors);
});

const toggle_edit = Array.from(document.querySelectorAll('.js-toggle-edit'));

if (toggle_edit.length > 0) {
  toggle_edit.forEach((elem) => {
    elem.addEventListener('click', () => {
      var el = document.getElementById('form_' + elem.dataset.id);
      el.style.display = el.style.display == 'none' ? '' : 'none';
    });
  });
}

const toggle_remove = Array.from(document.querySelectorAll('.js-toggle-remove'));

if (toggle_remove.length > 0) {
  toggle_remove.forEach((elem) => {
    elem.addEventListener('click', () => {
      // if (!confirm("Are you sure you wish to delete this address?")) return;
      const body = document.body;
      let confirmPopup = document.querySelector('.js-toggle-remove-popup'),
        cancelBtn = confirmPopup.querySelector('.js-toggle-remove-cancel'),
        confirmBtn = confirmPopup.querySelector('.js-toggle-remove-confirm');

      function disableTouchMove() {
        e.preventDefault();
      }

      function closeModal() {
        body.style.overflow = '';
        body.removeEventListener('touchmove', disableTouchMove);
        confirmPopup.classList.add('hidden');
      }

      // Disable scroll
      body.style.overflow = 'hidden';
      body.addEventListener('touchmove', disableTouchMove, false);
      confirmPopup.classList.remove('hidden');

      cancelBtn.addEventListener('click', closeModal);

      confirmBtn.addEventListener('click', () => {
        var form = document.createElement('form'),
          input = document.createElement('input');

        form.setAttribute('method', 'post');
        form.setAttribute('action', window.Shopify.routes.root + 'account/addresses/' + elem.dataset.id);
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', '_method');
        input.setAttribute('value', 'delete');

        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

        closeModal();
      });
    });
  });
}

const toggle = document.querySelector('.js-toggle-new-form')

if (toggle) {
  toggle.addEventListener('click', () => {
    var el = document.getElementById("form_new");
    el.style.display = el.style.display == "none" ? "" : "none";
  })
}
